var NewsFilter = /** @class */ (function () {
    function NewsFilter() {
        this.newsPage = document.querySelector('[data-news-page]');
        this.categories = this.newsPage.querySelectorAll('[data-news-cat]');
        this.showAllCategories = this.newsPage.querySelector('[data-show-all-cat]');
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.wordpressApiLink = "".concat(window.location.protocol, "//").concat(window.location.hostname, "/wp-admin/admin-ajax.php?action=news_filter");
        this.resultsContainer = this.newsPage.querySelector('[data-posts-results]');
        this.newsletterForm = this.newsPage.querySelector('.newsletter-form-posts');
        this.loadMoreButton = this.newsPage.querySelector('[data-load-more]');
        this.loadMore = false;
        this.page = 1;
        this.initializeSearchFromURL();
        this.addEventListeners();
    }
    NewsFilter.prototype.initializeSearchFromURL = function () {
        var _this = this;
        // Set filter from page url if any are set
        var currentUrl = new URL(window.location.href);
        var params = new URLSearchParams(currentUrl.search);
        // Check if url has any params - set appliedFilters from url
        if (params.keys().next().done === false) {
            params.forEach(function (filterValue, filterType) {
                if (filterValue !== '') {
                    // if not empty
                    _this.selectedNewsCategory = filterValue;
                    _this.revealCategoriesFromURL(filterValue);
                }
                else {
                    // if no value - delete from url
                    var currentUrl_1 = new URL(window.location.href);
                    var params_1 = new URLSearchParams(currentUrl_1.search);
                    params_1.delete(filterType);
                    currentUrl_1.search = params_1.toString();
                    window.history.replaceState({}, '', currentUrl_1.toString());
                }
            });
            this.loadApiResults(); // Load results from api based on applied filters
            this.setFilterValues(); // Set active filter elements based on applied filters
        }
    };
    NewsFilter.prototype.setFilterValues = function () {
        var _this = this;
        // Set active elements on page load based on applied filters
        this.categories.forEach(function (category) {
            // Get filter value from data attribute
            var value = category.getAttribute('data-news-cat');
            // Check if such filter type exist and if it has the value
            if (_this.selectedNewsCategory === value) {
                _this.newsPage.querySelector('[data-news-cat="all"]').classList.remove('active');
                category.classList.add('active');
            }
        });
    };
    NewsFilter.prototype.addEventListeners = function () {
        var _this = this;
        if (this.showAllCategories) {
            this.showAllCategories.addEventListener('click', this.revealAllCategories.bind(this));
        }
        this.categories.forEach(function (category) { return category.addEventListener('click', _this.categoryListener.bind(_this)); });
        this.loadMoreButton.addEventListener('click', this.loadMoreListener.bind(this));
    };
    NewsFilter.prototype.loadMoreListener = function (event) {
        event.preventDefault();
        this.loadMore = true;
        this.page++;
        if (this.newsletterForm && this.page !== 1) {
            this.newsletterForm.remove();
        }
        this.loadApiResults();
    };
    NewsFilter.prototype.revealAllCategories = function (event) {
        event.preventDefault();
        var categoriesContainer = this.showAllCategories.parentElement;
        var categories = categoriesContainer.querySelectorAll('.category');
        categories.forEach(function (element) {
            element.classList.remove('hidden');
            element.classList.add('visible');
        });
        this.showAllCategories.remove();
    };
    NewsFilter.prototype.revealCategoriesFromURL = function (categoryID) {
        var categoriesContainer = this.showAllCategories.parentElement;
        var categories = categoriesContainer.querySelectorAll('.category');
        var selectedCategory = categoriesContainer.querySelector("[data-news-cat=\"".concat(categoryID, "\"]"));
        if (selectedCategory && selectedCategory.classList.contains('hidden')) {
            selectedCategory.classList.remove('hidden');
            selectedCategory.classList.add('visible');
            categories.forEach(function (element) {
                element.classList.remove('hidden');
                element.classList.add('visible');
            });
            this.showAllCategories.remove();
        }
        else if (selectedCategory && !selectedCategory.classList.contains('hidden')) {
            selectedCategory.classList.add('active');
        }
    };
    NewsFilter.prototype.categoryListener = function (event) {
        event.preventDefault();
        var category = event.currentTarget;
        var isActive = category.classList.contains('active');
        var categoryValue = category.dataset.newsCat;
        var categoriesContainer = category.parentElement;
        var activeElements = categoriesContainer.querySelectorAll('.active');
        activeElements.forEach(function (element) { return element.classList.remove('active'); });
        if (isActive) {
            category.classList.remove('active');
            var isAnyActive = categoriesContainer.querySelector('.active') !== null;
            if (!isAnyActive) {
                // If no category set as active - set show all as active
                categoriesContainer.querySelector('[data-news-cat="all"]').classList.add('active');
            }
        }
        else {
            activeElements.forEach(function (element) { return element.classList.remove('active'); });
            category.classList.add('active');
            categoriesContainer.querySelector('[data-news-cat="all"]').classList.remove('active');
        }
        if (categoryValue === 'all') {
            categoriesContainer.querySelector('[data-news-cat="all"]').classList.add('active');
        }
        this.setCategory(categoryValue);
    };
    NewsFilter.prototype.setCategory = function (value) {
        this.selectedNewsCategory = value;
        this.page = 1;
        this.updatePageUrl(value);
        this.loadApiResults();
    };
    NewsFilter.prototype.updatePageUrl = function (value) {
        var currentUrl = new URL(window.location.href);
        var params = new URLSearchParams(currentUrl.search);
        var urlParamName = 'category';
        if (value === 'all') {
            // If value is "all," remove parameter from URL
            params.delete(urlParamName);
        }
        else {
            params.set(urlParamName, this.selectedNewsCategory.toString());
        }
        currentUrl.search = params.toString();
        window.history.replaceState({}, '', currentUrl.toString());
    };
    NewsFilter.prototype.loadApiResults = function () {
        var _this = this;
        // Load results from api based on applied categories
        this.body.classList.add('no-scroll');
        this.pageOverlay.classList.add('visible');
        this.pageLoader.classList.add('active');
        if (this.page === 1) {
            // If on first page
            this.resultsContainer.parentElement.classList.add('loading');
            this.newsPage.scrollIntoView({ behavior: "smooth" });
        }
        var options = {
            method: 'POST',
            body: JSON.stringify({
                category: this.selectedNewsCategory,
                page: this.page
            })
        };
        fetch(this.wordpressApiLink, options)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            _this.apiResults = response.html;
            _this.loadMore = response.loadMore;
            _this.setDomElements();
        })
            .catch(function (error) {
            console.error('Fetch error:', error);
        })
            .finally(function () {
            _this.body.classList.remove('no-scroll');
            _this.pageOverlay.classList.remove('visible');
            _this.pageLoader.classList.remove('active');
            _this.resultsContainer.parentElement.classList.remove('loading');
        });
    };
    NewsFilter.prototype.setDomElements = function () {
        // Set DOM elements based on api results
        if (this.page === 1) {
            this.resultsContainer.innerHTML = '';
            this.resultsContainer.innerHTML = this.apiResults;
        }
        else {
            this.resultsContainer.insertAdjacentHTML('beforeend', this.apiResults);
            var lastPostRow = this.resultsContainer.querySelector('.loaded-post-row');
            lastPostRow.classList.remove('loaded-post-row'); // Remove class for future loads
        }
        if (this.loadMore) {
            // Check if load more is true and load more button is hidden - show load more button
            this.loadMoreButton.classList.remove('hidden');
        }
        else {
            this.loadMoreButton.classList.add('hidden');
        }
    };
    return NewsFilter;
}());
export default NewsFilter;
